// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E4gh9","label":"styles_label__2Um3x"};